import React from 'react'

const AuthLoading = ({ error = null }) => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-muted">
      <img
        src="https://tm2-assets.ams3.cdn.digitaloceanspaces.com/images/shared/logos/logo.svg"
        alt="Teach Me 2"
        width="150"
        className="mb-6"
      />
      <div className={error ? 'text-destructive' : 'text-muted-foreground'}>
        {error ? (
          <div className="text-center">
            <div>{error}</div>
            <div className="mt-2">Redirecting to login...</div>
          </div>
        ) : (
          'Loading...'
        )}
      </div>
    </div>
  )
}

export default AuthLoading
